import { CancellationFlow, IReason } from './types';

export const reasons: IReason[] = [
    {
        title: 'subscription.cancellationReason.forgetToCancel',
        flow: CancellationFlow.withReminderOffer,
        shortKey: 'forget_to_cancel',
    },
    {
        title: 'subscription.cancellationReason.tooExpensive',
        flow: CancellationFlow.withCancellingOffer,
        shortKey: 'too_expensive',
    },
    {
        title: 'subscription.cancellationReason.doNotHaveTime',
        flow: CancellationFlow.withPauseSubscription,
        shortKey: 'do_not_have_time',
    },
    {
        title: 'subscription.cancellationReason.notEnjoying',
        flow: CancellationFlow.withPlanSuggestion,
        shortKey: 'not_enjoying',
    },
    {
        title: 'subscription.cancellationReason.DoesNotMeetExpectations',
        flow: CancellationFlow.withPlanSuggestion,
        shortKey: 'app_not_meet_my_expectations',
    },
    {
        title: 'subscription.cancellationReason.noNeedForApp',
        flow: CancellationFlow.withPauseSubscription,
        shortKey: 'no_need_for_the_app',
    },
    {
        title: 'basics.other',
        flow: CancellationFlow.withFeedbackForm,
        shortKey: 'other',
    },
];
